<template>
    <div>
        <div class="flex flex-wrap gap-12">
            <action-button
                v-if="hasLegacyCampaigns"
                class="border-primary-80"
                no-icon
                @click="toggleWithArchived"
            >
                <template #before>
                    <checkbox
                        :checked="showArchived"
                        @change="toggleWithArchived"
                    />
                </template>
                <span class="first-letter:uppercase">{{ archivedTitle }}</span>
            </action-button>
            <select-dropdown
                :auto-translate="false"
                icon="filter-alt"
                :multiple="true"
                :options="sortStatus"
                :placeholder="$t('multi-posting.campaigns.filters.status')"
                reference="value"
                remove-icon
                v-model="filters.status"
            />
            <select-dropdown
                :auto-translate="false"
                icon="filter-list"
                :options="sortOptions"
                :placeholder="$t('multi-posting.campaigns.filters.sort')"
                no-auto-sort
                v-model="filters.sort"
            />
            <simple-input
                icon="search"
                :placeholder="$t('multi-posting.campaigns.filters.search')"
                v-model="filters.search"
             />
        </div>
        <active-filters
            :items="activeFilters"
            @remove="removeItem"
            @remove-all="filters.status = []"
        />
    </div>
</template>

<script>
import SelectDropdown from "../forms/SelectDropdown.vue";
import SimpleInput from "../forms/Input.vue";
import SvgIcon from "../ui/SvgIcon.vue";
import {mapActions, mapState} from "pinia";
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../../state/store';
import {useMultiPostingStore} from '../../state/modules/multiPosting';
import _ from "lodash";
import { filters } from "../../services/JobService";
import PaidSubscription from "../../models/PaidSubscription";
import ActiveFilters from './form/ActiveFilters.vue';
import SimpleDropdown from "../ui/SimpleDropdown.vue";
import SimpleButton from "../ui/SimpleButton.vue";
import DropdownItem from "../ui/DropdownItem.vue";
import ActionButton from "../ui/ActionButton.vue";
import checkbox from "../forms/Checkbox.vue";

export default {
    name: 'CampaignFilters',
    components: {
        checkbox, ActionButton,
        DropdownItem,
        SimpleButton,
        SimpleDropdown,
        SimpleInput,
        SelectDropdown,
        SvgIcon,
        'active-filters': ActiveFilters
    },
    data: function () {
        return {
            filters: {
                search: '',
                sort: 'newest_first',
                status: [],
            },
            showArchived: false,
        }
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany']),
        ...mapState(useMultiPostingStore, ['campaigns', 'hasLegacyCampaigns']),
        hasMultiPostingSubscription() {
            return !!this.multiPostingSubscription && this.currentCompany.multiposting_status === 'active';
        },
        multiPostingSubscription() {
            return useRepo(PaidSubscription)
                .where('type', 'multi-posting')
                .where('company_id', this.currentCompany.id)
                .where('active', true)
                .first();
        },
        sortOptions() {
            const options = [
                {
                    value: 'newest_first',
                    label: this.$t('general.sort.date.desc'),
                },
                {
                    value: 'oldest_first',
                    label: this.$t('general.sort.date.asc'),
                },
                {
                    value: 'price_low_to_high',
                    label: this.$t('general.sort.price.low_to_high'),
                },
                {
                    value: 'price_high_to_low',
                    label: this.$t('general.sort.price.high_to_low'),
                }
            ]

            for(let i = 0; i < options.length; i++) {
                options[i].label = options[i].label.charAt(0).toUpperCase() + options[i].label.slice(1);
            }

            return options;
        },
        sortStatus() {
            const options = [
                {
                    value: 'draft',
                    label: this.$t('multi-posting.campaigns.status.draft'),
                },
                {
                    value: 'online',
                    label: this.$t('multi-posting.campaigns.status.online'),
                },
                {
                    value: 'offline',
                    label: this.$t('multi-posting.campaigns.status.offline'),
                },
                {
                    value: 'in progress',
                    label: this.$t('multi-posting.campaigns.status.in_progress'),
                },
                {
                    value: 'cancelled',
                    label: this.$t('multi-posting.campaigns.status.cancelled'),
                },
            ]

            for (let i = 0; i < options.length; i++) {
                options[i].label = options[i].label.charAt(0).toUpperCase() + options[i].label.slice(1);
            }

            return options;
        },
        onFilterChanges() {
            const DEBOUNCE_TIME = 500;
            const filter = {
                    search: this.filters.search,
                    sort: this.filters.sort,
                    status: this.filters.status,
            };
            return _.debounce(() => {
                this.$emit('filter-changes', filter);
            }, DEBOUNCE_TIME);
        },
        activeFilters() {
            const filters = [];
            for (let i = 0; i < this.filters['status'].length; i++) {
                filters.push({
                    label: this.filters['status'][i].charAt(0).toUpperCase() + this.filters['status'][i].slice(1)
                });
            }
            return filters;
        },
        archivedTitle() {
            return this.$t('campaigns.archived').toLowerCase() + ' ' + this.$t('campaigns.intro.title').toLowerCase();
        },
    },
    methods: {
        removeItem(item) {
            this.filters.status = this.filters.status.filter(status => status !== item.label.toLowerCase());
        },
        toggleWithArchived() {
            this.showArchived = !this.showArchived;
            this.$emit('filter-archived', this.showArchived);
        }
    },
    watch: {
        filters: {
            handler: function() {
                for (var key in this.filters) {
                    if (this.filters[key] === 'null' || this.filters[key] === null) {
                        this.filters[key] = '';
                    }
                }
                this.onFilterChanges();
            },
            deep: true,
        },
    },
 }
</script>